export const MODAL_ACTIONS = ['show', 'hide'] as const;

export type ModalAction = (typeof MODAL_ACTIONS)[number];

export const isModalAction = (value: unknown): value is ModalAction =>
  MODAL_ACTIONS.some((action) => action === value);

/** The `command` a native `commandfor` button sends for each Modal action. */
export const MODAL_ACTION_COMMANDS = {
  show: 'show-modal',
  hide: 'close',
} as const satisfies Record<ModalAction, string>;

export type ModalCommand = (typeof MODAL_ACTION_COMMANDS)[ModalAction];

export const getModalActionCommand = (action: ModalAction): ModalCommand =>
  MODAL_ACTION_COMMANDS[action];
